/* AppDetailsAndScope.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { AppScopes } from '@atlassian/mpac-ui';
import { List } from 'immutable';
import { useScopesLookup } from '../../hooks';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _5 = "@media (min-width:64rem){._10m41m5y{flex-grow:0.4}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._1yagoahv{padding:var(--ds-space-600,3pc)}._165t1osq{height:100%}._1mbp1wug{overflow-y:auto}}";
const _4 = "._4t3i1wug{height:auto}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const appDetailsAndScopeContainer = null;
export const AppDetailsAndScope = _ref => {
  let {
    appDetails,
    appHeader,
    links,
    graphQLGatewayUrl
  } = _ref;
  const {
    scopesLookup
  } = useScopesLookup(graphQLGatewayUrl);
  const appScopesList = List(appDetails.appScopes.map(scope => appDetails.deploymentType === 'MarketplaceCloudAppDeployment' ? scope.capability : scope.id));
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsxs("div", {
      className: ax(["_1yt41ejb _1e0c1txw _2lx21bp4 _4t3i1wug _10m41m5y _1vdkkb7n _1wznf1ug _1yagoahv _165t1osq _1mbp1wug"]),
      children: [appHeader, appDetails.appScopes && scopesLookup.isRight() && /*#__PURE__*/_jsx(AppScopes, {
        appScopes: appScopesList,
        scopesLookup: scopesLookup,
        description: "".concat(appDetails.appName, " will perform the following actions:"),
        links: links
      })]
    })]
  });
};